import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import type { OfferListResponse } from 'services/offer/hooks/useOfferList'
import {
  LocationOnOutlined,
  CalendarTodayOutlined,
  HomeOutlined,
  InsertPhotoOutlined
} from '@mui/icons-material'
import Section, { SectionCover } from 'components/Section'
import { OfferButton } from './Offer'
import { useIntl } from 'react-intl'
import dayjs from 'dayjs'

const OfferCard: FC<{ offer: OfferListResponse; onSeeOffer: () => void }> = ({
  offer,
  onSeeOffer
}) => {
  const { formatMessage } = useIntl()

  return (
    <Section
      sx={{
        flexDirection: 'column',
        alignItems: 'flex-start',
        mx: '18px',
        width: '100%',
        maxWidth: '530px'
      }}>
      <Box sx={{ width: '100%' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            marginBottom: '14px'
          }}>
          {!offer.flat?.photos[0]?.file ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '137px',
                minWidth: '290px',
                maxWidth: '680px',
                objectFit: 'cover'
              }}>
              <InsertPhotoOutlined sx={{ color: '#707070', width: '32px', height: '32px' }} />
              <Typography
                sx={{
                  textAlign: 'center'
                }}>
                {formatMessage({
                  id: 'offer.noImages',
                  defaultMessage: 'Brak zdjęć'
                })}
              </Typography>
            </Box>
          ) : (
            <SectionCover
              src={offer.flat?.photos[0]?.file}
              alt=''
              sx={{
                height: '137px',
                minWidth: '290px',
                maxWidth: '680px',
                objectFit: 'cover'
              }}
            />
          )}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography sx={{ width: '100%', height: '100%', fontWeight: 600, fontSize: 20 }}>
            {offer.investmentName}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '9px',
            marginBottom: '54px',
            gap: '9px'
          }}>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
            <LocationOnOutlined sx={{ width: '16px', height: '16px' }} />
            <Typography sx={{ width: '100%', fontWeight: 500, fontSize: '14px' }}>
              {offer.flat.address}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
            <HomeOutlined sx={{ width: '16px', height: '16px' }} />
            <Typography sx={{ width: '100%', fontWeight: 500, fontSize: '14px' }}>
              {offer.flatType}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
            <CalendarTodayOutlined sx={{ width: '16px', height: '16px' }} />
            <Typography sx={{ width: '100%', fontWeight: 500, fontSize: '14px' }}>
              {dayjs(offer.availableOn).format('DD/MM/YYYY')}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}>
            <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>{+offer.price} zł</Typography>
            <Typography sx={{ fontWeight: 500 }}>
              {formatMessage({
                id: 'offer.perMonth',
                defaultMessage: '/mies.'
              })}
            </Typography>
          </Box>
          <OfferButton
            children={formatMessage({
              id: 'offer.seeTheOffer',
              defaultMessage: 'Obejrzyj'
            })}
            sx={{ maxHeight: '26px', cursor: 'pointer' }}
            onClick={onSeeOffer}
          />
        </Box>
      </Box>
    </Section>
  )
}

export default OfferCard
